/**
 * TASK PAGE — Combina TaskList (home page) + TaskForm (side panel).
 * La home page dell'applicazione.
 */

import { useState } from 'react';
import TaskList from '../../entities/task/TaskList';
import TaskForm from '../../entities/task/TaskForm';

export function TaskPage() {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <TaskList onCreateClick={() => setShowForm(true)} />
      {showForm && (
        <TaskForm mode="modal" onClose={() => setShowForm(false)} />
      )}
    </>
  );
}
